module.exports = __webpack_public_path__ + "static/media/meta_default.de689be6.png";